export default __webpack_public_path__ + "static/card_1-8ca869073a7a25c0f9fd56eb8467caa8.svg";